import { get } from 'api';
import { cleanObject } from 'utils/object';

import { CUSTOMERS_LOADED, LOAD_CUSTOMERS, RESET_CUSTOMERS, SYNC_FAILED } from './actionTypes';
import type { IGetCustomersParams } from './types';

export const initialActionsState = {
  loadCustomers: () => {},
  resetCustomers: () => {},
};

export const getActions = (dispatch: { (value: { type: any; payload?: any }): void }) => ({
  loadCustomers: async (params: IGetCustomersParams = {}, onDone, ignoreIsLoading = false) => {
    if (!ignoreIsLoading) {
      dispatch({
        type: LOAD_CUSTOMERS,
      });
    }

    const { data, error } = await get('/customers', { params: cleanObject(params) });

    if (!error) {
      dispatch({
        type: CUSTOMERS_LOADED,
        payload: Array.isArray(data) ? data : [],
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    if (onDone) onDone(Array.isArray(data) ? data : [], error);
  },

  resetCustomers: () =>
    dispatch({
      type: RESET_CUSTOMERS,
    }),
});
